export interface TabData {
  title: string;
  icon?: string;
  child: GameItem[];
}

const colecao1: TabData[] = [
  {
    title: 'Favoritos',
    child: [
      {
        name: 'Fortune Horse',
        slug: 'pgsoft/fortune-horse',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/d9606439-0993-42d3-8162-2ee24138df00',
      },
      {
        name: 'Aviator',
        slug: 'spribe/aviator',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/60e3555c-8ec0-494f-8b19-e750952c8700',
      },
      {
        name: 'Roleta Brasileira',
        slug: 'playtech/roleta-brasileira',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/30c3b40d-a9eb-470f-e25d-2f57fd18f100',
      },
      {
        name: 'Fortune Rabbit',
        slug: 'pgsoft/fortune-rabbit',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/68fb0abb-161b-4d29-66ae-92bab5455400',
      },
      {
        name: 'Bac Bo',
        slug: 'evolution/bac-bo',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/e8126729-c7b5-4ae7-a825-f4553d871300',
      },
      {
        name: 'Fortune Tiger',
        slug: 'pgsoft/fortune-tiger',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/1842bc52-4be2-46c8-425d-3ff4284cc900',
      },
      {
        name: 'Gates of Olympus',
        slug: 'pragmaticplay/gates-of-olympus',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/e2c37fe8-ec4b-4392-19b2-a9186a2faa00',
      },
      {
        name: 'JetX',
        slug: 'smartsoft/jetx',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/977dae6d-1599-47dd-60d8-1ff9e0319800',
      },
    ],
  },
  {
    title: 'Slots',
    child: [
      {
        name: 'Fortune Rabbit',
        slug: 'pgsoft/fortune-rabbit',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/68fb0abb-161b-4d29-66ae-92bab5455400',
      },
      {
        name: 'Fortune Tiger',
        slug: 'pgsoft/fortune-tiger',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/1842bc52-4be2-46c8-425d-3ff4284cc900',
      },
      {
        name: 'Gates of Olympus Super Scatter',
        slug: 'pragmaticplay/gates-of-olympus-super-scatter',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/c9e2519c-e2f1-4038-0704-2b33ec0d4f00',
      },
      {
        name: 'Sweet Bonanza 1000',
        slug: 'pragmaticplay/sweet-bonanza-1000',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/b6e9968b-4d3d-479e-7a39-8e913cdc1500',
      },
      {
        name: 'Rico Gorila',
        slug: 'popok/rico-gorila',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/6de3d5dd-97ec-40f1-b3f6-9de123a43700',
      },
      {
        name: 'Yo Dragon',
        slug: 'popok/yo-dragon',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/e6e32e6e-c357-40da-2187-17c69a06b800',
      },
      {
        name: 'Le Bandit',
        slug: 'hacksaw/le-bandit',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/c00900fa-109d-4405-b538-667d8d9e3200',
      },
      {
        name: 'Ze Zeus',
        slug: 'hacksaw/ze-zeus',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/7ee8d662-1595-491e-5706-901b37af2e00',
      },
      {
        name: 'Fortune Dragon',
        slug: 'pgsoft/fortune-dragon',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/6877aa14-1920-42ff-903c-1d03be2f2f00',
      },
      {
        name: 'Fortune Ox',
        slug: 'pgsoft/fortune-ox',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/4e1cea21-7fd8-4d1b-1532-19d186c1dd00',
      },
      {
        name: 'Fortune Panda',
        slug: 'popok/fortune-panda',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/191e5558-5397-4540-5e5d-307645b7ae00',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/slots',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
  {
    title: 'Roletas',
    child: [
      {
        name: 'Roleta Brasileira',
        slug: 'playtech/roleta-brasileira',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/f3085a00-5316-4101-7112-8a72a894da00',
      },
      {
        name: 'Roleta Brasileira',
        slug: 'pragmaticplay/roleta-brasileira',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/3dd4f47e-e70d-40e8-5be4-b458f397b300',
      },
      {
        name: 'Immersive Roulette',
        slug: 'evolution/immersive-roulette',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/7056bbf7-f555-4f68-802c-c4459cfade00',
      },
      {
        name: 'Roleta Brasileira',
        slug: 'imaginelive/roleta-brasileira',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/b00a4f19-a944-4652-08ed-ab3728cd1d00',
      },
      {
        name: 'Mega Roleta',
        slug: 'pragmaticplay/mega-roleta',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/89fafb88-ed03-4fcb-a697-c701cc27c300',
      },
      {
        name: 'Speed Roulette 1',
        slug: 'pragmaticplay/speed-roulette-1',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/ec8e459b-8c3f-4495-98c9-16a0079aa800',
      },
      {
        name: 'Auto-Roulette',
        slug: 'evolution/auto-roulette',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/c1c3c766-9b82-4280-077d-8a65fb7dcc00',
      },
      {
        name: 'Roleta Ao Vivo',
        slug: 'evolution/roleta-ao-vivo',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/735b66c7-681f-4d8e-9668-1fdb39308500',
      },
      {
        name: 'Roleta Relâmpago',
        slug: 'evolution/roleta-relampago',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/c543b6e5-e309-443e-fa88-9698f2698e00',
      },
      {
        name: 'Auto-Roulette 1',
        slug: 'pragmaticplay/auto-roulette-1',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/fb8857ae-fb71-476e-07ce-a64e3db81100',
      },
      {
        name: 'XXXtreme Lightning Roulette',
        slug: 'evolution/xxxtreme-lightning-roulette',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/6dead537-c874-411c-b6ca-a9c8c9d89200',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/roleta',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
  {
    title: 'Crash',
    child: [
      {
        name: 'Aviator',
        slug: 'spribe/aviator',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/8b0470e5-bb04-49f0-a4e8-59458490d100',
      },
      {
        name: 'JetX',
        slug: 'smartsoft/jetx',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/8ab8bd1c-5d29-4e28-ad70-38274b8bce00',
      },
      {
        name: 'Aviador',
        slug: 'hype/aviador',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/77f5546f-c87e-47ee-4079-dcca032a3d00',
      },
      {
        name: 'Mines',
        slug: 'spribe/mines',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/1778a297-c565-4b08-3e5d-b1c90892d700',
      },
      {
        name: 'Aviator Crash',
        slug: 'banana/aviator-crash',
        image:
          'https://imagedelivery.net/BgH9d8bzsn4n0yijn4h7IQ/716d8d07-456f-4450-808e-eb16f1bdb700',
      },
      {
        name: 'Live - Spaceman',
        slug: 'pragmaticplay/live-spaceman',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/365edc65-fcf3-4ac5-4dc8-904417086e00',
      },
      {
        name: 'High Flyer',
        slug: 'pragmaticplay/high-flyer',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/f0eeb9ba-6c9b-435a-8a7b-c378d8f49e00',
      },
      {
        name: 'Avi',
        slug: 'popok/avi',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/3c1bca61-18bf-4b16-827d-fcab46a85200',
      },
      {
        name: 'FootballX',
        slug: 'smartsoft/footballx',
        image:
          'https://imagedelivery.net/BgH9d8bzsn4n0yijn4h7IQ/88863e5a-c804-4387-6f05-ca75a9a00300',
      },
      {
        name: 'Baccarat',
        slug: 'hacksaw/baccarat',
        image:
          'https://imagedelivery.net/BgH9d8bzsn4n0yijn4h7IQ/19f016c7-ec13-4b9d-58ff-49cef1eac900',
      },
      {
        name: 'Banana Mines',
        slug: 'banana/banana-mines',
        image:
          'https://imagedelivery.net/BgH9d8bzsn4n0yijn4h7IQ/274602c2-fb54-472e-ac30-f2d8ce943f00',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/all?initialCategory=jogos-crash',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
  {
    title: 'Cassino ao Vivo',
    child: [
      {
        name: 'Bac Bo',
        slug: 'evolution/bac-bo',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/cc91f156-8ff8-4553-9cc7-667b608d4000',
      },
      {
        name: 'BAC BO AO VIVO',
        slug: 'evolution/bac-bo-ao-vivo',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/56b15151-a9ea-4f0f-09eb-b1f607a0d100',
      },
      {
        name: 'Football studio',
        slug: 'evolution/football-studio',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/099e4598-4123-44ed-681b-03d59a843e00',
      },
      {
        name: 'Double Max',
        slug: 'banana/double-max',
        image:
          'https://imagedelivery.net/BgH9d8bzsn4n0yijn4h7IQ/c5e082fe-7bef-4df6-b2f6-457f4ece3a00',
      },
      {
        name: 'Crazy Time',
        slug: 'evolution/crazy-time',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/88865839-8bd3-49c2-14c0-e776db40fc00',
      },
      {
        name: 'Adventures Beyond Wonderland Live',
        slug: 'playtech/adventures-beyond-wonderland-live',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/093d18fc-83f4-4725-463a-d89d1fffbe00',
      },
      {
        name: 'Futebol Studio Ao Vivo',
        slug: 'evolution/futebol-studio-ao-vivo',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/d8189bc4-c837-4b95-17f8-c9b216726c00',
      },
      {
        name: 'Speed Baccarat A',
        slug: 'evolution/speed-baccarat-a',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/41ff9204-a21d-4a68-1088-4efd42da0100',
      },
      {
        name: 'Live - Mega Wheel',
        slug: 'pragmaticplay/live-mega-wheel',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/8740bf3b-0c5c-48c4-a44f-d77136f6f200',
      },
      {
        name: 'Live - Speed Baccarat 7',
        slug: 'pragmaticplay/live-speed-baccarat-7',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/6590f997-5453-4469-b91c-392f9b8e0000',
      },
      {
        name: 'Live - Speed Baccarat 10',
        slug: 'pragmaticplay/live-speed-baccarat-10',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/93cc6cde-5d91-4b51-a280-ba5ca13b3900',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/cassino-ao-vivo',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
];

const colecao2: TabData[] = [
  {
    title: 'PgSoft',
    child: [
      {
        id: '1543462',
        name: 'Fortune Rabbit',
        slug: 'pgsoft/fortune-rabbit',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/68fb0abb-161b-4d29-66ae-92bab5455400',
      },
      {
        id: '126',
        name: 'Fortune Tiger',
        slug: 'pgsoft/fortune-tiger',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/1842bc52-4be2-46c8-425d-3ff4284cc900',
      },
      {
        id: '1695365',
        name: 'Fortune Dragon',
        slug: 'pgsoft/fortune-dragon',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/6877aa14-1920-42ff-903c-1d03be2f2f00',
      },
      {
        id: '98',
        name: 'Fortune Ox',
        slug: 'pgsoft/fortune-ox',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/4e1cea21-7fd8-4d1b-1532-19d186c1dd00',
      },
      {
        id: '1492288',
        name: 'Pinata Wins',
        slug: 'pgsoft/pinata-wins',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/22f0e89d-32ed-4770-965f-ac221d2eec00',
      },
      {
        name: 'Mr. Treasures Fortune',
        slug: 'pgsoft/mr-treasures-fortune',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/b5a58051-695b-4fb6-1943-78b00acf3600',
      },
      {
        id: '1778752',
        name: 'Futebol Fever',
        slug: 'pgsoft/futebol-fever',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/c9dccb50-a301-47c2-9a4c-39e8513fee00',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/all?initialCategory=slots&initialProvider=pgsoft',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
  {
    title: 'Pragmatic',
    child: [
      {
        name: 'Gates of Olympus',
        slug: 'pragmaticplay/gates-of-olympus',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/71c24ebe-c82c-4599-4fe8-39161b5d4a00',
      },
      {
        id: 'pragmaticplay/gates-of-olympus-1000',
        name: 'Gates of Olympus 1000',
        slug: 'pragmaticplay/gates-of-olympus-1000',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/9c632b3a-7f7b-433e-444e-1857bf866b00',
      },
      {
        id: 'vs20olympgold',
        name: 'Gates of Olympus Super Scatter',
        slug: 'pragmaticplay/gates-of-olympus-super-scatter',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/c9e2519c-e2f1-4038-0704-2b33ec0d4f00',
      },
      {
        id: 'vs20fruitswx',
        name: 'Sweet Bonanza 1000',
        slug: 'pragmaticplay/sweet-bonanza-1000',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/b6e9968b-4d3d-479e-7a39-8e913cdc1500',
      },
      {
        id: 'vs20sugarrushx',
        name: 'Sugar Rush 1000',
        slug: 'pragmaticplay/sugar-rush-1000',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/506b3ff7-1b03-4368-3837-e1c672fa0b00',
      },
      {
        name: 'Starlight Princess Super Scatter',
        slug: 'pragmaticplay/starlight-princess-super-scatter',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/3c38151c-2672-43da-a351-94fb5009ec00',
      },
      {
        id: 'pragmaticplay/touro-sortudo',
        name: 'Touro Sortudo',
        slug: 'pragmaticplay/touro-sortudo',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/a108aaf1-7790-4f1b-e4c6-f2dd7cda1300',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/all?initialCategory=slots&initialProvider=pragmaticplay',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
  {
    title: 'Popok',
    child: [
      {
        name: 'Yo Dragon',
        slug: 'popok/yo-dragon',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/e6e32e6e-c357-40da-2187-17c69a06b800',
      },
      {
        name: 'Rico Toucano',
        slug: 'popok/rico-toucano',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/339fcc30-2f3e-4e3a-70d8-1c651aa1d000',
      },
      {
        name: 'Rico Gorila',
        slug: 'popok/rico-gorila',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/6de3d5dd-97ec-40f1-b3f6-9de123a43700',
      },
      {
        name: 'Sumo Baby',
        slug: 'popok/sumo-baby',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/1b4a23e9-5276-419b-c51f-344eb6d6c400',
      },
      {
        name: 'Fortune Panda',
        slug: 'popok/fortune-panda',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/191e5558-5397-4540-5e5d-307645b7ae00',
      },
      {
        name: 'Papai Noel da Fortuna',
        slug: 'popok/papai-noel-da-fortuna',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/96c55268-8396-4460-d8e2-b1e5b9e5f300',
      },
      {
        id: '2',
        name: 'Diamond Flash',
        slug: 'popok/diamond-flash',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/6c4dcce5-b6db-4a9f-5938-ae5a4d2a5000',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/all?initialCategory=slots&initialProvider=popok',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
  {
    title: 'Hacksaw',
    child: [
      {
        name: 'Le Bandit',
        slug: 'hacksaw/le-bandit',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/c00900fa-109d-4405-b538-667d8d9e3200',
      },
      {
        name: 'Wanted Dead or a Wild',
        slug: 'hacksaw/wanted-dead-or-a-wild',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/a13e9b77-f392-43cf-2782-b0984424aa00',
      },
      {
        id: 'hacksaw/ze-zeus',
        name: 'Ze Zeus',
        slug: 'hacksaw/ze-zeus',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/7ee8d662-1595-491e-5706-901b37af2e00',
      },
      {
        name: 'Le Cowboy',
        slug: 'hacksaw/le-cowboy',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/eb698904-7715-45e2-2096-b8d68d77bb00',
      },
      {
        name: 'Mines',
        slug: 'hacksaw/mines',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/1a2e4c14-ad80-4b78-4005-3a3180f21500',
      },
      {
        id: 'hacksaw:DannyDollar96',
        name: 'Danny Dollar',
        slug: 'hacksaw/danny-dollar',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/9984d4b6-cce7-4875-df9f-278c9f8da100',
      },
      {
        id: 'hacksaw:RIPCity',
        name: 'RIP City',
        slug: 'hacksaw/rip-city',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/c713d258-cc8a-4d31-ef2a-d38ee2611500',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/all?initialCategory=slots&initialProvider=hacksaw',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
  {
    title: 'Tada',
    child: [
      {
        name: 'Fortune Coins',
        slug: 'tada/fortune-coins',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/3f43343f-790e-46ec-f959-79f7623bcd00',
      },
      {
        name: 'Money Coming',
        slug: 'tada/money-coming',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/ade269e3-6746-4168-06bf-29f0ca646c00',
      },
      {
        name: 'Money Coming Expanded Bets',
        slug: 'tada/money-coming-expanded-bets',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/f116f55d-cd37-42e1-59c4-56f0dda7aa00',
      },
      {
        name: 'Money Pot',
        slug: 'tada/money-pot',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/9b36a2f5-d11c-4546-033e-f2d99e0ed100',
      },
      {
        name: 'Lucky Jaguar',
        slug: 'tada/lucky-jaguar',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/81cdadb6-3f77-4c5b-44b5-5fa7d73a2400',
      },
      {
        name: 'Lucky Jaguar 2',
        slug: 'tada/lucky-jaguar-2',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/32595fa9-f7bb-461a-34f5-a5f5bbdf1100',
      },
      {
        id: '664',
        name: 'Onça Sortuda 500',
        slug: 'tada/onca-sortuda-500',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/0345720e-b3a5-4d97-f28f-aead982a9a00',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/all?initialCategory=slots&initialProvider=tada',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
];

const colecao3: TabData[] = [
  {
    title: 'Evolution',
    child: [
      {
        id: 'evolution:BacBo',
        name: 'Bac Bo',
        slug: 'evolution/bac-bo',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/cc91f156-8ff8-4553-9cc7-667b608d4000',
      },
      {
        id: 'evolution:BacBoAoVivo',
        name: 'BAC BO AO VIVO',
        slug: 'evolution/bac-bo-ao-vivo',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/56b15151-a9ea-4f0f-09eb-b1f607a0d100',
      },
      {
        id: 'evolution/speed-baccarat-a',
        name: 'Speed Baccarat A',
        slug: 'evolution/speed-baccarat-a',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/41ff9204-a21d-4a68-1088-4efd42da0100',
      },
      {
        id: 'evolution:top_card',
        name: 'Football studio',
        slug: 'evolution/football-studio',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/099e4598-4123-44ed-681b-03d59a843e00',
      },
      {
        id: 'evolution/auto-roulette',
        name: 'Auto-Roulette',
        slug: 'evolution/auto-roulette',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/c1c3c766-9b82-4280-077d-8a65fb7dcc00',
      },
      {
        id: 'evolution/baccarat-a',
        name: 'Baccarat A',
        slug: 'evolution/baccarat-a',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/6a6d6125-0900-4e12-9fb7-7094504ae400',
      },
      {
        name: 'Blackjack VIP 22',
        slug: 'evolution/blackjack-vip-22',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/351167d6-ae10-4e79-5fe9-f15c9f854a00',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/all?initialCategory=cassino-ao-vivo&initialProvider=evolution',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
  {
    title: 'Pragmatic',
    child: [
      {
        name: 'Live - Speed Baccarat 7',
        slug: 'pragmaticplay/live-speed-baccarat-7',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/5f138f0c-7d26-4d1c-64bf-f4d02dba9c00',
      },
      {
        name: 'Live - No Comm Speed Baccarat 1',
        slug: 'pragmaticplay/live-no-comm-speed-baccarat-1',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/0346f260-2431-472e-0bca-0acadada7700',
      },
      {
        name: 'Live - Speed Baccarat 8',
        slug: 'pragmaticplay/live-speed-baccarat-8',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/8e2d9b31-c9e7-4844-0fe9-dd15f858ca00',
      },
      {
        name: 'Blackjack 11',
        slug: 'pragmaticplay/blackjack-11',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/527c9606-ec3e-4eec-2a04-6b96ed364600',
      },
      {
        name: 'Live - Speed Baccarat 10',
        slug: 'pragmaticplay/live-speed-baccarat-10',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/6c883c6c-f5e2-4573-03c8-f834afb24e00',
      },
      {
        name: 'Live - Mega Wheel',
        slug: 'pragmaticplay/live-mega-wheel',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/49b1e4d2-cb72-4ae7-a91f-b550851e6400',
      },
      {
        name: 'Live - Sweet Bonanza CandyLand',
        slug: 'pragmaticplay/live-sweet-bonanza-candyland',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/b2b05b74-23fb-43d1-f726-387f7adfb500',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/all?initialCategory=cassino-ao-vivo&initialProvider=pragmaticplay',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
  {
    title: 'Playtech',
    child: [
      {
        id: 'playtech/adventures-beyond-wonderland-live',
        name: 'Adventures Beyond Wonderland Live',
        slug: 'playtech/adventures-beyond-wonderland-live',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/093d18fc-83f4-4725-463a-d89d1fffbe00',
      },
      {
        id: 'playtech/brazilian-mega-fire-blaze-lucky-ball-live',
        name: 'Brazilian Mega Fire Blaze Lucky Ball Live',
        slug: 'playtech/brazilian-mega-fire-blaze-lucky-ball-live',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/e594762b-9bfe-4d23-4a77-c82ab5b8a100',
      },
      {
        name: 'Premium Blackjack',
        slug: 'playtech/premium-blackjack',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/1d3e9c10-5fdb-4de1-94de-165d51bc6600',
      },
      {
        name: 'The Greatest Cards Show',
        slug: 'playtech/the-greatest-cards-show',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/662d3f6f-5d66-4b36-90bd-f4516890f100',
      },
      {
        name: 'Spin a Win Live',
        slug: 'playtech/spin-a-win-live',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/cd59176f-f21f-4580-c296-ce80392c4500',
      },
      {
        name: 'Live Dragon Tiger',
        slug: 'playtech/live-dragon-tiger',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/b4f7733e-b6b3-43a4-1cd4-d86ca4f10100',
      },
      {
        name: 'Pyramid Linx',
        slug: 'playtech/pyramid-linx',
        image:
          'https://imagedelivery.net/BgH9d8bzsn4n0yijn4h7IQ/5982be28-b102-4e66-a592-bd0039955300',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/all?initialCategory=cassino-ao-vivo&initialProvider=playtech',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
];

const colecao4: TabData[] = [
  {
    title: 'Crash',
    child: [
      {
        id: 'aviator',
        name: 'Aviator',
        slug: 'spribe/aviator',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/8b0470e5-bb04-49f0-a4e8-59458490d100',
      },
      {
        id: 'banana/aviator-crash',
        name: 'Aviator Crash',
        slug: 'banana/aviator-crash',
        image:
          'https://imagedelivery.net/BgH9d8bzsn4n0yijn4h7IQ/716d8d07-456f-4450-808e-eb16f1bdb700',
      },
      {
        id: 'hype/aviador',
        name: 'Aviador',
        slug: 'hype/aviador',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/17379bb0-f3ba-4e35-6ff9-e6235915f000',
      },
      {
        id: '18',
        name: 'JetX',
        slug: 'smartsoft/jetx',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/8ab8bd1c-5d29-4e28-ad70-38274b8bce00',
      },
      {
        id: 'evolution:RedBaron',
        name: 'Red Baron',
        slug: 'evolution/red-baron',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/98970b93-7ac5-4cfb-9b2d-ae398e3b2700',
      },
      {
        id: '2201',
        name: 'High Flyer',
        slug: 'pragmaticplay/high-flyer',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/f0eeb9ba-6c9b-435a-8a7b-c378d8f49e00',
      },
      {
        id: '1301',
        name: 'Live - Spaceman',
        slug: 'pragmaticplay/live-spaceman',
        image:
          'https://imagedelivery.net/TjsK7FMOjGj8BrLfedhFqw/365edc65-fcf3-4ac5-4dc8-904417086e00',
      },
      {
        name: 'ApostaTudo',
        slug: 'category/all?initialCategory=jogos-crash',
        image: getAssetsUrlForCDN('/assets/images/ver-todos-card.webp'),
      },
    ],
  },
];

export const customTabsCollections: Record<string, TabData[]> = {
  colecao1,
  colecao2,
  colecao3,
  colecao4,
};
